import React, {PureComponent} from "react"
import styled, {css} from "styled-components"
import {Row} from "@irati/ui/src/Layout"
import {get} from "lodash"

import isColorLight from "@irati/ui/src/global/isColorLight"
import Button from "@irati/ui/src/Button"
import {H2} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

const PageHeader = styled(Row)`
  margin-bottom: ${({theme}) => theme.spacing.eight};
`

const Pill = styled.div`
  ${({theme}) => css`
    display: inline-block;
    background-color: ${(props) => get(props, "color") || theme.colors.brand.default};
    border-radius: 15px;
    color: ${(props) =>
      isColorLight(get(props, "color") || theme.colors.brand.default) ? theme.colors.greys.black : theme.colors.greys.white};
    font-size: 12px;
    margin-left: ${theme.spacing.one};
    margin-top: 18px;
    padding: 2px 10px;
    position: relative;
  `}
`

const DescWrapper = styled.div`
  clear: both;
  margin-top: ${({theme}) => theme.spacing.four};
`

const StyledH2 = styled(H2)`
  display: inline-block;
  word-break: break-word;
`

interface Props {
  count: number
  onClick(): void
}

class CompanyValuesTitle extends PureComponent<Props> {
  render() {
    const {count, onClick} = this.props

    return (
      <PageHeader>
        <Flex justifyContent="space-between" alignItems="center">
          <Flex alignItems="flex-start">
            <StyledH2>
              <FormattedMessage id="admin.companyValues.list.header" />
            </StyledH2>
            <Pill>
              <FormattedMessage id="admin.companyValues.list.headerCount" values={{count}} />
            </Pill>
          </Flex>
          <Button id="settingsCompanyValuesAdd_button" onClick={onClick} primary>
            <FormattedMessage id="admin.companyValues.list.add" />
          </Button>
        </Flex>
        <DescWrapper>
          <FormattedMessage id="admin.companyValues.list.desc" />
        </DescWrapper>
      </PageHeader>
    )
  }
}

export default CompanyValuesTitle
